module.exports = __webpack_public_path__ + "img/banner4.08e0bd44.jpg";